import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPatch, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  CallReviewAnnotation,
  LlmCallAnnotations,
  LlmTurnAnnotation,
} from './types';

export const addCallReviewAnnotation = ({
  accountId,
  projectId,
  conversationId,
  annotations,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  annotations: { turn_id: number; annotation_type: string; role: string }[];
}) => {
  return doPut<CallReviewAnnotation>(
    generateNextPath(ENDPOINTS.CALL_REVIEW_ANNOTATIONS, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.CONVERSATIONS,
    {
      annotations,
    },
  );
};

export const deleteCallReviewAnnotation = ({
  accountId,
  projectId,
  conversationId,
  annotationIds,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  annotationIds: number[];
}) => {
  return doDelete<CallReviewAnnotation>(
    generateNextPath(ENDPOINTS.CALL_REVIEW_ANNOTATIONS, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.CONVERSATIONS,
    {
      annotation_ids: annotationIds,
    },
  );
};

export const getLlmCallAnnotations = ({
  accountId,
  projectId,
  conversationId,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
}) => {
  return doGet<LlmCallAnnotations>(
    generateNextPath(ENDPOINTS.LLM_CALL_ANNOTATIONS, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.CONVERSATIONS,
  );
};

export const updateLlmTurnAnnotation = ({
  accountId,
  projectId,
  conversationId,
  turnNumber,
  annotation,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  turnNumber: string;
  annotation: { rating: number; reasons: string[] | null };
}) => {
  return doPatch<LlmTurnAnnotation>(
    generateNextPath(ENDPOINTS.LLM_TURN_ANNOTATION, {
      accountId,
      projectId,
      conversationId,
      turnNumber,
    }),
    LOGGER_TYPE.CONVERSATIONS,
    annotation,
  );
};
